import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps, extractClassNamesFromProps } from '../Common'
import * as st from './Packshot.module.scss'

export interface LegacyImageProps {
    src: string
    alt?: string
}

export interface PackshotProps extends BaseComponentProps {
    src?: string
    alt?: string
    onLoad?: (a?: React.SyntheticEvent<HTMLImageElement>) => void
    onError?: (a?: React.SyntheticEvent<HTMLImageElement>) => void
    onClick?: (a?: React.MouseEvent) => unknown
    url?: string
    isPrime?: boolean
    playPercent?: number
    overlay?: any
    image?: LegacyImageProps // TODO: Remove this when users have migrated (Remaining - Storefront)
    asin?: string
}

interface imgProps {
    complete: boolean
}

export interface PackshotState {
    src: string
    alt: string
    isPrime: boolean
}

export class Packshot extends React.Component<PackshotProps, PackshotState> {
    playPercent?: number | boolean
    overlay: any
    img?: imgProps | null

    constructor(props: PackshotProps) {
        super(props)

        const legacyImageObj = props.image || { src: '', alt: '' }

        this.state = {
            alt: props.alt || legacyImageObj.alt || '',
            src: props.src || legacyImageObj.src,
            isPrime: props.isPrime || false
        }
    }

    onLoad(e?: React.SyntheticEvent<HTMLImageElement>) {
        const customOnLoad = this.props.onLoad || (() => {})
        customOnLoad(e)
    }

    onError(e?: React.SyntheticEvent<HTMLImageElement>) {
        const customOnError = this.props.onError || (() => {})
        customOnError(e)
    }

    onClick(e?: React.MouseEvent) {
        const customOnClick = this.props.onClick || (() => {})
        customOnClick(e)
    }

    componentDidMount() {
        // This fires the onLoad event if the image has already loaded before the component mounts.
        // It's proved almost impossible to test due to the way React tests are designed.
        /* istanbul ignore if  */
        if (this.img && this.img.complete) {
            this.onLoad()
        }
    }

    static getDerivedStateFromProps(props: PackshotProps) {
        const legacyImageObj = props.image || { src: '', alt: '' }

        return {
            alt: props.alt || legacyImageObj.alt || '',
            src: props.src || legacyImageObj.src,
            isPrime: props.isPrime || false
        }
    }

    render() {
        const classNames = extractClassNamesFromProps(
            this.props,
            st.packshot,
            'dvui-packshot'
        )

        const image = () => (
            <>
            {this.state.isPrime && <span className={st.primeLogo} />}
            {this.props.children ||
               (<img
                    src={this.state.src}
                    alt={this.state.alt}
                    onLoad={this.onLoad.bind(this)}
                    onError={this.onError.bind(this)}
                    onClick={this.onClick.bind(this)}
                    ref={elem => (this.img = elem)}
                />)
            }

            {Boolean(this.props.playPercent) && (
                <div className={st.progressContainer}>
                    <div
                        className={st.progressBar}
                        style={{ width: `${this.props.playPercent}%` }}
                    />
                </div>
            )}
            </>
        )

        return (
            <div className={classNames} data-asin={this.props.asin}>
                {this.props.url && <a href={this.props.url}>
                    {image()}
                </a>}
                {!this.props.url && image()}
                {this.props.overlay &&
                    <div className={st.overlay}>
                        {this.props.overlay}
                    </div>
                }
            </div>
        )
    }
}
